var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e42235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1225"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#079b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007b5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd117"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd93b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd117"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e21c30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1225"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12.952381v8.380952h-12.952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12.952381v8.380952h-12.952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12.952381v8.380952h-12.952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12.952381v8.380952h-12.952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    fillRule: "nonzero",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    fillRule: "nonzero",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(1.52381 1.52381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12.952381v8.380952h-12.952381z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.9865744 4.26579328c.21571597.34521773.52541602.57309228.81387419.6315731.15880716.03219591-.13195117-.69610189-.00524754-.77527511.1081093-.06755419.62825818.53809198.67380562.41173476.10479624-.29072457.04297601-.70241954-.19016851-1.07552877-.3344758-.53527318-.34753345-.18198318-1.25175389-.56544981.09454185.54838921-.37498568.83767266-.04050987 1.37294583z",
    fill: "url(#e)",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h12.952381l-6.47619052 4.19047619zm0 8.38095238 6.47619048-4.19047619 6.47619052 4.19047619z",
    fill: "url(#f)",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.47619,
    cy: 4.190476,
    fill: "url(#g)",
    mask: "url(#k)",
    r: 1.904762
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.47619048 4.77813112-.89567277.64513287.33677972-1.05119244-.89033593-.6524784 1.10381408-.00453978.3454149-1.0483867.34541489 1.0483867 1.10381406.00453978-.89033591.6524784.33677972 1.05119244z",
    fill: "url(#e)",
    mask: "url(#l)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/GD.4340dcfd5dcfbd0c22595d2d15142a25.svg";
export { ForwardRef as ReactComponent };